import React from 'react'
import styled from 'styled-components'
import { Col, Typography, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import Ufrn from '../../assets/ufrn.png'
import Robot from '../../assets/robot.png'
import Trader from '../../assets/trader.png'
import Intelbras from '../../assets/intelbras.png'
import Esig from '../../assets/esig.gif'

const { Paragraph } = Typography;

const WorkList = (props) => {

    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    const {t} = useTranslation()
    
    const works = [
        {
            id: 1,
            icon: Intelbras,
            title: 'Bolsista Desenvolvimento Frontend',
            employmentType: 'Pesquisador',
            company: 'UFRN - Intelbras',
            location: 'Natal, Rio Grande do Norte',
            currently: true,
            start: new Date(2020, 3),
            end: new Date(),
            description: 'Aprimorar a solução do WiseFi, introduzindo novas capacidades em consonância às tendências tecnológicas e avanços em pesquisa, particularmente nas áreas da Computação em Nuvem e Internet das Coisas, de modo a atender aos novos requisitos de mercado relacionados com gestão de redes corporativas.',
        },
        {
            id: 2,
            icon: Ufrn,
            title: 'Bolsa de Iniciação Científica',
            employmentType: 'Pesquisador',
            company: 'UFRN',
            location: 'Natal, Rio Grande do Norte',
            currently: true,
            start: new Date(2019, 7),
            end: new Date(),
            description:  'Atuo como bolsista voluntário no projeto de desenvolvimento da plataforma nefroatlas que tem por foco o ensino de conteúdos específicos para estudantes de medicina que desejam realizar prova de título na área de nefrologia.',
        },
        {
            id: 3,
            icon: Esig,
            title: 'Desenvolvedor Frontend',
            employmentType: 'Estagiário',
            company: 'ESIG Software e Consultoria em TI',
            location: 'Natal, Rio Grande do Norte',
            currently: false,
            start: new Date(2019,9),
            end: new Date(2019,3),
            description: 'Estágio na área de desenvolvimento frontend do sistema QuarkClinic criado pela ESIG. Nele aplico conhecimentos das boas práticas de programação assim como faço uso de tecnologias em alta no mercado. Uso do framework Angular para desenvolvimento de aplicações voltadas para web e NativeScript para aplicações nativas em dispositivos móveis',
        },
        {
            id: 4,
            icon: Ufrn,
            title: 'Desenvolvedor Frontend',
            employmentType: 'Freelance',
            company: 'Autonomo',
            location: 'Natal, Rio Grande do Norte',
            currently: true,
            start: new Date(2018,10),
            end: new Date(),
            description: 'Desenvolvedor Frontend da plataforma educacional nefroatlas. O projeto faz parte do Mestrado Profissional em Ensino na Saúde em andamento do Dr Felipe Guedes com quem atuo diretamente no desenvolvimento de conteúdo para a plataforma.',
        },
        {
            id: 5,
            icon: Robot,
            title: 'Desenvolvedor Frontend',
            employmentType: 'Freelance',
            company: 'Autonomo',
            location: 'Natal, Rio Grande do Norte',
            currently: false,
            start: new Date(2019, 5),
            end: new Date(2019, 7),
            description: 'Desenvolvimento do frontend de Website para empresa especializada na criação e comercialização de robôs de trading.',
        },
        {
            id: 6,
            icon: Trader,
            title: 'Desenvolvedor Frontend',
            employmentType: 'Freelance',
            company: 'Autonomo',
            location: 'Natal, Rio Grande do Norte',
            currently: false,
            start: new Date(2019, 7),
            end: new Date(2019, 8),
            description: 'Desenvolvimento do frontend de website para clientes de trading que buscam consultoria e servidores para rodar suas aplicações. A empresa tem como foco o share profit',
        },
        {
            id: 7,
            icon: Ufrn,
            title: 'Bolsa de Iniciação Científica',
            employmentType: 'Bolsista',
            company: 'UFRN',
            location: 'Natal, Rio Grande do Norte',
            currently: false,
            start: new Date(2018, 10),
            end: new Date(2019, 4),
            description: 'Atuei como voluntário no trabalho de iniciação científica atuando na área de testes de software com foco na Implementação de ferramenta de análise estática para deteção automática de code smells',
        },
    ]
    
    return (
        <>
            {works.map(item => {
                return (
                    <>
                        {item.id <= props.displayed && 
                        
                        <Col xs={24} sm={24} md={20} lg={props.col} xl={props.col} key={item.id} style={{lineHeight: '1.5rem'}}>
                            <Row justify='center'>
                                {!(props.displayed === 3) && 
                                <Col style={{display: 'flex',justifyContent: 'center',alignItems: 'center'}} xs={24} sm={24} md={props.displayed !== 3 ? 6 : 0} lg={props.displayed !== 3 ? 6 : 0} xl={props.displayed !== 3 ? 6 : 0}>
                                    <Img src={item.icon} />
                                </Col>}
                                <Col style={{padding: '30px 20px'}} xs={24} sm={24} md={props.displayed !== 3 ? 18 : 24} lg={props.displayed !== 3 ? 18 : 24} xl={props.displayed !== 3 ? 18 : 24}>
                                    <H3>{item.title}</H3>
                                    <P>{item.employmentType} ( {item.company} )</P>
                                    <Small>{item.location}</Small><br />
                                    {/* eslint-disable-next-line */}
                                    <Small>{`${months[item.start.getMonth()]} ` + `${item.start.getFullYear()}`} - {item.currently ? `${t('Presente')}` : `${months[item.end.getMonth()]} ` + `${item.end.getFullYear()}`}</Small>
                                    <Paragraph ellipsis={{rows: 2, expandable: true}}>
                                        {item.description}
                                    </Paragraph>
                                </Col>
                            </Row>
                        </Col>}
                    </>
                )
            })}
        </>
    )
}


export default WorkList

const H3 = styled.h3`
    margin: 0;
    padding: 0;
    font-size: 18px;
`

const P = styled.p`
    margin: 0;
    padding: 0;
`

const Small = styled.small`
    margin: 0;
    padding: 0;
`

const Img = styled.img`
    width: 150px;
    height: 150px;
`